import { render, staticRenderFns } from "./PropostaPagamentoEdit.vue?vue&type=template&id=882f2e2e"
import script from "./PropostaPagamentoEdit.vue?vue&type=script&lang=js"
export * from "./PropostaPagamentoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports